import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Heading } from '@digdir/designsystemet-react';
import { BarChartIcon, FileTextIcon } from '@navikt/aksel-icons';
import { Routes } from '../../../enums/Routes';
import { buildRoute } from '../../../utils/routeBuilder';
import classes from '../CustomSurveyTemplateTrendsPage.module.css';

type TemplateHeaderProps = {
  templateId: string;
  /** Malens navn, når det er lastet */
  title?: string;
  /** Undersøkelsen «Én undersøkelse» går til: den siste, eller den som vises */
  surveyId?: number;
};

/** Brødsmuler, tittel og valget mellom utvikling over tid og én undersøkelse */
export const TemplateHeader = ({ templateId, title, surveyId }: TemplateHeaderProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const trendsPath = buildRoute(Routes.DashboardCustomSurveyTemplateTrends, { templateId });

  return (
    <>
      <nav aria-label={t('breadcrumbs.ariaLabel')} className="ds-breadcrumbs">
        <ol>
          <li>
            <Link to={Routes.DashboardCustomSurveys} className="ds-link">
              {t('customSurveys.dashboard.sectionTitle')}
            </Link>
          </li>
          {title && (
            <li>
              <Link to={trendsPath} className="ds-link" aria-current={pathname === trendsPath ? 'page' : undefined}>
                {title}
              </Link>
            </li>
          )}
        </ol>
      </nav>
      {title && (
        <>
          <div className={classes.titleBlock}>
            <span className={classes.eyebrow}>{t('customSurveys.templateTrends.eyebrow')}</span>
            <Heading level={2} data-size="lg">
              {title}
            </Heading>
          </div>
          <nav aria-label={t('customSurveys.templateTrends.views.label')}>
            <ul className={classes.views}>
              <li>
                <NavLink to={trendsPath} end className={classes.view}>
                  <BarChartIcon aria-hidden />
                  {t('customSurveys.templateTrends.views.trends')}
                </NavLink>
              </li>
              {surveyId !== undefined && (
                <li>
                  <NavLink
                    to={buildRoute(Routes.DashboardCustomSurveySurvey, { templateId, surveyId })}
                    end
                    className={classes.view}
                  >
                    <FileTextIcon aria-hidden />
                    {t('customSurveys.templateTrends.views.single')}
                  </NavLink>
                </li>
              )}
            </ul>
          </nav>
        </>
      )}
    </>
  );
};
